import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER').plugin(axiosPlugin);


let fetchUserAction = redux.fetchActionGetOne();

export const fetchUser = (userId) => fetchUserAction(`/users/${userId}`);
export const resetUser = () => redux.actions.reset();

export const user = redux.reducer();